module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"top10":"上位10店舗","top20":"上位20店舗","bottom10":"下位10店舗","bottom20":"下位20店舗","all":"全店","ranking":"ランキング","tooltip":"店舗の各KPIごとのランキングを確認することができます。 表の下にあるボタンより表示する店舗数を設定することができます。","store":"店舗","store_code":"店舗番号","value":"実数","variation":"変動"}}')
  delete Component.options._Ctor
}
